import { render, staticRenderFns } from "./4d-special.vue?vue&type=template&id=b3d56ffc&lang=pug&"
import script from "./4d-special.vue?vue&type=script&lang=js&"
export * from "./4d-special.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports